import { AuthLayout } from '../components/AuthLayout';
import { AuthHeroPanel } from '../components/AuthHeroPanel';
import { LoginForm } from '../components/LoginForm';

/**
 * Login Page
 * Two-panel layout with hero image and login form
 * Auth redirect logic is now handled by AppRouter route guards
 */
export function LoginPage() {
  return (
    <AuthLayout showSignUpLink>
      <div className="w-full max-w-[95vw] sm:max-w-[600px] lg:max-w-[1000px] xl:max-w-[1100px] grid grid-cols-1 lg:grid-cols-2 bg-surface rounded-lg sm:rounded-xl shadow-auth-card overflow-hidden border border-primary/5">
        {/* Left Panel - Hero */}
        <AuthHeroPanel />

        {/* Right Panel - Form */}
        <LoginForm />
      </div>
    </AuthLayout>
  );
}
